<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import date from 'locutus/php/datetime/date'
import { mapGetters, mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  page: {
    title: 'BrokerageConsole::Index',
    meta: [{ name: 'description', content: 'BrokerageConsole::Index' }],
  },
  components: { BrokerageConsoleLayout },
  computed: {
    ...mapState('common', { constants: (state) => state.constants }),
    ...mapGetters('brokerage', ['brokerage_info']),
  },
  methods: {
    fromPairs,
    date,
  },
}
</script>

<template>
  <BrokerageConsoleLayout>
    <h3 :class="$style.xeAdmin">{{ $t('index.broker_information') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr v-if="brokerage_info.parent_seq">
          <th scope="row"
            ><div>{{ $t('index.control_point') }}</div></th
          >
          <td colspan="3">
            {{ brokerage_info.title }}
          </td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.control_point') }}</div></th
          >
          <td :colspan="3">{{ brokerage_info.title }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.id') }}</div></th
          >
          <td>
            {{ brokerage_info.user_id }}
          </td>
          <th scope="row"
            ><div>{{ $t('index.unique_number') }}</div></th
          >
          <td>{{ brokerage_info.seq }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.tax_payer_number') }}</div></th
          >
          <td>
            <ElTooltip effect="light" :content="$t('index.number')">
              {{ brokerage_info.taxpayer_idn }}
            </ElTooltip>
          </td>
          <th scope="row"
            ><div>{{ $t('index.broker_type') }}</div></th
          >
          <td>
            {{
              fromPairs(constants.brokerage.brokerage_type)[
                brokerage_info.brokerage_type
              ]
            }}
          </td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.phone_number') }}</div></th
          >
          <td>{{ brokerage_info.landline }}</td>
          <th scope="row"
            ><div>{{ $t('index.registration_date') }}</div></th
          >
          <td>{{ date('Y-m-d H:i:s', new Date(brokerage_info.regdate)) }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.address') }}</div></th
          >
          <td colspan="3">{{ brokerage_info.address }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('index.identification_code') }}</div></th
          >
          <td colspan="3">{{ brokerage_info.identification_code }}</td>
        </tr>
      </tbody>
    </table>
  </BrokerageConsoleLayout>
</template>
<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
